/* Gül Reizen (Hault, 2026-09): reveal, tabellen, inhoudsopgave, galerij en reserveerflow. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var euro = function (cents) { return '€ ' + Math.round(cents / 100).toLocaleString('nl-NL'); };

  /* Reveal on scroll */
  var rev = $$('.g-rev');
  if (rev.length) {
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    } else { rev.forEach(function (el) { el.classList.add('is-in'); }); }
  }

  /* Tabellen scrollbaar maken */
  $$('.g-rte table').forEach(function (t) {
    if (t.parentNode.classList.contains('g-tablewrap')) return;
    var w = document.createElement('div'); w.className = 'g-tablewrap';
    t.parentNode.insertBefore(w, t); w.appendChild(t);
  });

  /* Inhoudsopgave uit de h2's */
  var toc = $('[data-g-toc]'), body = $('[data-g-content]');
  if (toc && body) {
    var hs = $$('h2', body);
    if (hs.length < 3) { var box = toc.closest('.g-box'); if (box) box.hidden = true; }
    else {
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'deel-' + (i + 1);
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); toc.appendChild(li);
      });
      if ('IntersectionObserver' in window) {
        var links = $$('a', toc);
        var so = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        hs.forEach(function (h) { so.observe(h); });
      }
    }
  }

  /* Galerij */
  var lb = $('[data-g-lightbox]');
  if (lb) {
    var lbImg = $('img', lb), last = null;
    var close = function () { lb.removeAttribute('data-open'); lbImg.removeAttribute('src'); if (last) last.focus(); };
    $$('[data-g-gallery] button').forEach(function (b) {
      b.addEventListener('click', function () {
        last = b; lbImg.src = b.getAttribute('data-full'); lbImg.alt = ($('img', b) || {}).alt || '';
        lb.setAttribute('data-open', ''); $('button', lb).focus();
      });
    });
    lb.addEventListener('click', function (e) { if (e.target !== lbImg) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.hasAttribute('data-open')) close(); });
  }

  /* Reserveerflow */
  var res = $('[data-g-reserve]');
  if (!res) return;
  var deposit = parseInt(res.getAttribute('data-deposit'), 10) * 100 || 0;
  var depVariant = res.getAttribute('data-deposit-variant');
  var state = { pax: 1, inf: 0 };
  var lim = { pax: [1, 12], inf: [0, 4] };
  var words = ['', 'een', 'twee', 'drie', 'vier'];

  var restDate = (function () {
    var s = res.getAttribute('data-start'); if (!s) return '';
    var p = s.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]); d.setMonth(d.getMonth() - 1);
    return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
  })();
  if (restDate) $$('[data-g-restdate]', res).forEach(function (el) { el.textContent = restDate; });

  function room() { return $('input[name="g-room"]:checked', res); }

  function render() {
    var r = room(); if (!r) return;
    var price = parseInt(r.getAttribute('data-price'), 10), size = parseInt(r.getAttribute('data-size'), 10) || 0;
    var label = r.getAttribute('data-label');
    var total = price * state.pax, now = deposit * state.pax, rest = total - now;
    $('[data-out="pax"]', res).textContent = state.pax;
    $('[data-out="inf"]', res).textContent = state.inf;
    $$('[data-step]', res).forEach(function (b) {
      var k = b.getAttribute('data-for'), n = state[k] + parseInt(b.getAttribute('data-step'), 10);
      b.disabled = n < lim[k][0] || n > lim[k][1];
    });
    $('[data-g-sumline]', res).textContent = state.pax + (state.pax === 1 ? ' reiziger' : ' reizigers') + ' in een ' + label.toLowerCase();
    $('[data-g-total]', res).textContent = euro(total);
    $('[data-g-rest]', res).textContent = euro(rest);
    $('[data-g-now]', res).textContent = euro(now);
    var n2 = $('[data-g-now2]', res); if (n2) n2.textContent = euro(now);

    var hint = $('[data-g-hint]', res), msg = '';
    if (size === 4 && state.pax < 4) msg = 'Je deelt de vierpersoonskamer met andere reizigers uit de groep. Wij delen de kamers zorgvuldig in.';
    else if ((size === 2 || size === 3) && state.pax % size !== 0) {
      msg = state.pax < size
        ? 'Een ' + label.toLowerCase() + ' boek je met ' + words[size] + ' personen samen. Reis je met minder personen, kies dan de vierpersoonskamer of bel ons voor advies.'
        : 'Met ' + state.pax + ' reizigers komt de kamerindeling niet precies uit op ' + label.toLowerCase() + 's. Wij bellen je na je reservering om de indeling af te stemmen.';
    }
    if (state.inf > 0) msg += (msg ? ' ' : '') + 'Voor baby’s betaal je nu niets aan. Wij nemen contact met je op over het tarief.';
    hint.textContent = msg; hint.hidden = !msg;

    var f = { room: label, pax: state.pax, inf: state.inf, total: euro(total), now: euro(now) };
    Object.keys(f).forEach(function (k) { var el = $('[data-g-f="' + k + '"]', res); if (el) el.value = f[k]; });
    return { price: price, label: label, total: total, now: now, rest: rest };
  }

  $$('[data-step]', res).forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-for'), n = state[k] + parseInt(b.getAttribute('data-step'), 10);
      if (n >= lim[k][0] && n <= lim[k][1]) { state[k] = n; render(); }
    });
  });
  $$('input[name="g-room"]', res).forEach(function (i) { i.addEventListener('change', render); });

  var tog = $('[data-g-toggle]', res), form = $('#g-res-form', res);
  if (tog && form) tog.addEventListener('click', function () {
    var open = !form.hasAttribute('data-open');
    form.toggleAttribute('data-open', open); tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var first = $('input:not([type=hidden])', form); if (first) first.focus(); }
  });
  /* Verborgen formuliervelden mogen de checkout-knop niet blokkeren */
  if (form) {
    var req = $$('[required]', form);
    var sync = function () { var on = form.hasAttribute('data-open'); req.forEach(function (el) { el.required = on; }); };
    sync(); if (tog) tog.addEventListener('click', sync);
  }

  var pay = $('[data-g-pay]', res), err = $('[data-g-payerr]', res);
  if (pay && depVariant) pay.addEventListener('click', function () {
    var s = render(); if (!s) return;
    pay.disabled = true; if (err) err.hidden = true;
    var props = {
      'Reis': res.getAttribute('data-trip'),
      'Reisdata': res.getAttribute('data-dates'),
      'Kamertype': s.label,
      'Reizigers vanaf 2 jaar': String(state.pax),
      'Baby’s tot 2 jaar': String(state.inf),
      'Reissom totaal': euro(s.total),
      'Restbedrag': euro(s.rest) + (restDate ? ' (uiterlijk ' + restDate + ')' : '')
    };
    var post = function (url, data) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data || {}) })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    };
    post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', { items: [{ id: parseInt(depVariant, 10), quantity: state.pax, properties: props }] }); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        pay.disabled = false;
        if (err) { err.textContent = 'Online aanbetalen lukt nu even niet. Reserveer zonder online betaling of bel ons, dan regelen wij het samen.'; err.hidden = false; }
      });
  });

  /* Mobiele balk verbergen zodra de reserveerkaart in beeld is */
  var bar = $('[data-g-mbar]');
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { bar.toggleAttribute('data-hide', es[0].isIntersecting); }, { threshold: 0.15 }).observe(res);
  }
  /* Kaart hoger dan het scherm: onderkant laten plakken, zodat de knop bereikbaar blijft */
  var fit = function () {
    if (!matchMedia('(min-width: 1061px)').matches) { res.style.top = ''; return; }
    var h = res.offsetHeight, v = window.innerHeight;
    res.style.top = h > v - 128 ? (v - h - 24) + 'px' : '';
  };
  fit(); window.addEventListener('resize', fit);
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(res);
  /* Terug uit de kassa of van een andere pagina: knop weer bruikbaar en bedragen gelijk aan de gekozen kamer */
  window.addEventListener('pageshow', function () { if (pay) pay.disabled = false; render(); });
  render();
})();
